import React from 'react';
import styled, { keyframes } from 'styled-components';

const OpacityAnimation = keyframes`
  from {opacity: 0};
  to {opacity: 1}
`;

const Content = styled.p`
  line-height: 1.7em;
  font-size: 16px !important;
  font-weight: bold !important;
  animation: ${OpacityAnimation} 0.7s;
  color: rgba(64, 64, 64, 1);
  text-align: left !important;

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
    margin: 20px 0 15px;
    text-align: left !important;
  }

  h1 { font-size: 20px !important;   }
  h2 { font-size: 18px !important;   }
  h3 { font-size: 16px !important;   }
  h4 { font-size: 14px !important;   }
  h5 { font-size: 13px !important;   }
  h6 { font-size: 13px !important;   }
  p {padding: 0; margin: 0;}
`;

const Explanation = ({ content }) => (
  <Content dangerouslySetInnerHTML={{ __html: content }} />
);

export default Explanation;
